var getLocation =(): Promise<GeolocationCoordinates>=>
	new Promise((resolve, reject)=>{
		if(!navigator.geolocation){
			reject(new Error('Geolocalización no disponible.'));
			return;
		}
		navigator.geolocation.getCurrentPosition(
			(pos) => resolve(pos.coords),
			() => reject(new Error('No se pudo obtener la ubicación. Verifica los permisos del navegador.')),
			{ timeout: 10000, maximumAge: 60000 }
		);
	});

var toTimeString =(unix: number)=>
	new Date(unix * 1000).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', hour12: true });

var minutesToClock =(m: number)=>
	`${Math.floor(m / 60).toString().padStart(2, '0')}:${(m % 60).toString().padStart(2, '0')}`;

var pad = (n: number) => n.toString().padStart(2, '0');

var formatCreditCard =(val: string)=>{
	var cleaned = (val || '').replace(/\D/g, '').slice(0, 16);
	return cleaned.replace(/(.{4})/g, '$1 ').trim();
}

var maskCLABE =(clabe: string)=>{
	if(!clabe || clabe.length < 5) return clabe || '';
	return `**${clabe.substring(clabe.length - 4)}`;
}

var maskCardNumber =(card_number: string)=>{
	if(!card_number) return '';
	var cleaned = card_number.replace(/\D/g, '');
	if(cleaned.length < 4) return card_number;
	return `**${cleaned.substring(cleaned.length - 4)}`;
}

var getBankFromCLABE =(clabe: string)=>{
	if(!clabe || clabe.length < 3) return null;
	var bankCode = clabe.substring(0, 3);
	var banks: Record<string, string> = {
		'002': 'Banamex',
		'012': 'BBVA Mexico',
		'014': 'Santander',
		'019': 'Banjercito',
		'021': 'HSBC',
		'030': 'Bajio',
		'032': 'IXE',
		'036': 'Inbursa',
		'037': 'Interacciones',
		'042': 'Mifel',
		'044': 'Scotiabank',
		'058': 'Banregio',
		'059': 'Invex',
		'060': 'Bansi',
		'062': 'Afirme',
		'072': 'Banorte',
		'106': 'Bank of America',
		'110': 'JP Morgan',
		'112': 'Bmonex',
		'113': 'Ve por Mas',
		'126': 'Credit Suisse',
		'127': 'Azteca',
		'128': 'Autofin',
		'130': 'Compartamos',
		'132': 'Multiva',
		'133': 'Actinver',
		'136': 'Intercam',
		'137': 'Bancoppel',
		'138': 'ABC Capital',
		'140': 'Consubanco',
		'141': 'Volkswagen',
		'143': 'CIBanco',
		'145': 'BBase',
		'147': 'Bankaool',
		'148': 'PagaTodo',
		'150': 'Inmobiliario',
		'151': 'Donde',
		'152': 'Bancrea',
		'154': 'Banco Finterra',
		'155': 'ICBC',
		'156': 'Sabadell',
		'157': 'Shinhan',
	};
	return banks[bankCode] || null;
}

var getBankParticipants =()=>[
	{ participant: 40133, bank_name: 'ACTINVER' },
	{ participant: 40062, bank_name: 'AFIRME' },
	{ participant: 90721, bank_name: 'albo' },
	{ participant: 0, bank_name: 'AMERICAN EXPRESS' },
	{ participant: 90706, bank_name: 'ARCUS FI' },
	{ participant: 90659, bank_name: 'ASP INTEGRA OPC' },
	{ participant: 40127, bank_name: 'AZTECA' },
	{ participant: 37166, bank_name: 'BaBien' },
	{ participant: 40030, bank_name: 'BAJIO' },
	{ participant: 40002, bank_name: 'BANAMEX' },
	{ participant: 40154, bank_name: 'BANCO COVALTO' },
	{ participant: 37006, bank_name: 'BANCOMEXT' },
	{ participant: 40137, bank_name: 'BANCOPPEL' },
	{ participant: 40160, bank_name: 'BANCO S3' },
	{ participant: 40152, bank_name: 'BANCREA' },
	{ participant: 37019, bank_name: 'BANJERCITO' },
	{ participant: 40147, bank_name: 'BANKAOOL' },
	{ participant: 40106, bank_name: 'BANK OF AMERICA' },
	{ participant: 40159, bank_name: 'BANK OF CHINA' },
	{ participant: 37009, bank_name: 'BANOBRAS' },
	{ participant: 40072, bank_name: 'BANORTE' },
	{ participant: 40058, bank_name: 'BANREGIO' },
	{ participant: 40060, bank_name: 'BANSI' },
	{ participant: 2001, bank_name: 'BANXICO' },
	{ participant: 40129, bank_name: 'BARCLAYS' },
	{ participant: 40145, bank_name: 'BBASE' },
	{ participant: 40012, bank_name: 'BBVA MEXICO' },
	{ participant: 40112, bank_name: 'BMONEX' },
	{ participant: 90677, bank_name: 'CAJA POP MEXICA' },
	{ participant: 90683, bank_name: 'CAJA TELEFONIST' },
	{ participant: 90715, bank_name: 'CASHI CUENTA' },
	{ participant: 90631, bank_name: 'CI BOLSA' },
	{ participant: 40124, bank_name: 'CITI MEXICO' },
	{ participant: 90901, bank_name: 'CLS' },
	{ participant: 90903, bank_name: 'CoDi Valida' },
	{ participant: 40130, bank_name: 'COMPARTAMOS' },
	{ participant: 40140, bank_name: 'CONSUBANCO' },
	{ participant: 90725, bank_name: 'COOPDESARROLLO' },
	{ participant: 90652, bank_name: 'CREDICAPITAL' },
	{ participant: 90688, bank_name: 'CREDICLUB' },
	{ participant: 90680, bank_name: 'CRISTOBAL COLON' },
	{ participant: 90723, bank_name: 'Cuenca' },
	{ participant: 90729, bank_name: 'Dep y Pag Dig' },
	{ participant: 40151, bank_name: 'DONDE' },
	{ participant: 90616, bank_name: 'FINAMEX' },
	{ participant: 90634, bank_name: 'FINCOMUN' },
	{ participant: 90734, bank_name: 'FINCO PAY' },
	{ participant: 90738, bank_name: 'FINTOC' },
	{ participant: 90699, bank_name: 'FONDEADORA' },
	{ participant: 90685, bank_name: 'FONDO (FIRA)' },
	{ participant: 90601, bank_name: 'GBM' },
	{ participant: 40167, bank_name: 'HEY BANCO' },
	{ participant: 37168, bank_name: 'HIPOTECARIA FED' },
	{ participant: 40021, bank_name: 'HSBC' },
	{ participant: 40155, bank_name: 'ICBC' },
	{ participant: 40036, bank_name: 'INBURSA' },
	{ participant: 90902, bank_name: 'INDEVAL' },
	{ participant: 40150, bank_name: 'INMOBILIARIO' },
	{ participant: 40136, bank_name: 'INTERCAM BANCO' },
	{ participant: 40059, bank_name: 'INVEX' },
	{ participant: 40110, bank_name: 'JP MORGAN' },
	{ participant: 40128, bank_name: 'KAPITAL' },
	{ participant: 90661, bank_name: 'KLAR' },
	{ participant: 90653, bank_name: 'KUSPIT' },
	{ participant: 90670, bank_name: 'LIBERTAD' },
	{ participant: 90602, bank_name: 'MASARI' },
	{ participant: 90722, bank_name: 'Mercado Pago W' },
	{ participant: 90720, bank_name: 'MexPago' },
	{ participant: 40042, bank_name: 'MIFEL' },
	{ participant: 40158, bank_name: 'MIZUHO BANK' },
	{ participant: 90600, bank_name: 'MONEXCB' },
	{ participant: 40108, bank_name: 'MUFG' },
	{ participant: 40132, bank_name: 'MULTIVA BANCO' },
	{ participant: 37135, bank_name: 'NAFIN' },
	{ participant: 40638, bank_name: 'NU MEXICO' },
	{ participant: 90710, bank_name: 'NVIO' },
	{ participant: 40148, bank_name: 'PAGATODO' },
	{ participant: 90732, bank_name: 'Peibo' },
	{ participant: 90714, bank_name: 'PPBALANCEMX' },
	{ participant: 90620, bank_name: 'PROFUTURO' },
	{ participant: 40156, bank_name: 'SABADELL' },
	{ participant: 40014, bank_name: 'SANTANDER' },
	{ participant: 40044, bank_name: 'SCOTIABANK' },
	{ participant: 40157, bank_name: 'SHINHAN' },
	{ participant: 90728, bank_name: 'SPIN BY OXXO' },
	{ participant: 90646, bank_name: 'STP' },
	{ participant: 90730, bank_name: 'Swap' },
	{ participant: 90703, bank_name: 'TESORED' },
	{ participant: 90684, bank_name: 'TRANSFER' },
	{ participant: 90727, bank_name: 'TRANSFER DIRECT' },
	{ participant: 40138, bank_name: 'UALA' },
	{ participant: 90656, bank_name: 'UNAGRA' },
	{ participant: 90617, bank_name: 'VALMEX' },
	{ participant: 90605, bank_name: 'VALUE' },
	{ participant: 40113, bank_name: 'VE POR MAS' },
	{ participant: 40141, bank_name: 'VOLKSWAGEN' },
];

export {
	getLocation,
	toTimeString,
	minutesToClock,
	pad,
	formatCreditCard,
	maskCLABE,
	maskCardNumber,
	getBankFromCLABE,
	getBankParticipants
}
